import React from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Select,
  Icon,
  message,
  InputNumber,
} from "antd";
import i18n from "i18next";
import axios from "axios";
import { get } from "lodash";
import moment from "moment";
import SelectQuery from "../../Lib/SelectQuery";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Lib from "../../Lib/Utils";
import LeadPreview from "../Leads/LeadPreview";
import "./Styles.less";

const FormItem = Form.Item;
const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

class TaskFormInit extends React.Component {
  state = {
    task: {},
    loading: false,
    visible: false,
    singleLoading: false,
    singleData: {},
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };
    // this.fetch();
    // if (this.props.match.params.taskID) {
    //     this.setState({
    //         requestType: 'put'
    //     });
    // }
  }

  fetchSingle = (leadID) => {
    axios
      .get(process.env.REACT_APP_AXIOS_URL + `/api/leads/${leadID}/`)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            singleData: res.data,
            singleLoading: false,
            visible: true,
          });
        } else {
          message.error("Something went wrong");
        }
      })
      .catch((error) => {});
  };

  handleState = (key, value) => {
    let obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // e.stopPropagation();
    this.setState({ loading: true });
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.handleFormSubmit(
          values,
          e,
          this.props.requestType,
          this.props.data.id
        );
      }
    });
  };

  viewValue = (value, isButton) => {
    if (isButton) {
      return (
        <Button
          icon="container"
          type="dashed"
          onClick={() => this.fetchSingle(value.id)}
          className="ant-form-text"
        >
          {get(value, "name")}
        </Button>
      );
    }
    return (
      <div className="left-border">
        <span className="ant-form-text">{value}</span>
      </div>
    );
  };

  handleFormSubmit = (values, event, requestType, taskID) => {
    let filtered_assigned_to = this.props.users.filter((item) => {
      if (values.assigned_to && values.assigned_to.includes(item.id))
        return true;
    });
    let filtered_tags = this.props.tags.filter((item) => {
      if (values.tags && values.tags.includes(item.slug)) return true;
    });
    let filtered_contacts = this.props.contacts.filter((item) => {
      if (values.contacts && values.contacts.includes(item.id)) return true;
    });

    let due_date;
    if (values.due_date == undefined) due_date = null;
    else due_date = values.due_date.format(dateFormat);

    let lead;
    if (values.lead == undefined) lead = null;
    else lead = values.lead.key;

    const postObj = {
      title: values.title,
      status: values.status,
      priority: values.priority,
      description: values.description,
      due_date: due_date,
      hours_worked: values.hours_worked,
      assigned_to: filtered_assigned_to,
      created_by: values.created_by,
      // created_on: event.target.elements.created_on.value,
      tags: filtered_tags,
      contacts: filtered_contacts,
      lead: lead,
    };

    if (requestType === "post") {
      axios
        .post(process.env.REACT_APP_AXIOS_URL + "/api/tasks/create/", postObj)
        .then((res) => {
          if (res.status === 201) {
            message.success("Sucessfully created");
            this.props.handleState("modalVisible", false);
            this.props.fetch();
          }
          this.setState({ loading: false });
        })
        .catch((res) => {
          console.log(res);
          this.setState({ loading: false });
          Lib.responseMessage("error", res.data);
        });
    } else if (requestType === "put") {
      axios
        .put(
          process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/update/`,
          postObj
        )
        .then((res) => {
          if (res.status === 200) {
            Lib.responseMessage(
              "success",
              `Sucessfully update task ${values.title}`
            );
            this.props.handleState("modalVisible", false);
            this.props.fetch();
          }
          this.setState({ loading: false });
        })
        .catch((res) => {
          this.setState({ loading: false });
          Lib.responseMessage("error", get(res, "response.data"));
        });
    }
    // if (success)
    //     this.props.handleState('modalVisible', false);
  };

  handleDelete = (event) => {
    event.preventDefault();
    const taskID = this.props.match.params.taskID;
    axios
      .delete(process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/delete/`)
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          this.props.fetch();
        }
      });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { onCancel, requestType, visible, btnText, data, titleText, t } =
      this.props;
    const [s] = [this.state];

    let tags_filtered,
      users_filtered,
      contacts_filtered,
      created_by,
      lead = [];
    if (requestType === "put") {
      tags_filtered = this.props.data.tags.map((item) => {
        return item.slug;
      });
      users_filtered = this.props.data.assigned_to.map((item) => {
        return item.id;
      });
      contacts_filtered = this.props.data.contacts.map((item) => {
        return item.id;
      });
    } else if (requestType === "get") {
      tags_filtered = this.props.data.tags.map((item) => {
        return item.name + ", ";
      });
      users_filtered = this.props.data.assigned_to.map((item) => {
        return item.first_name + " " + item.last_name + ", ";
      });
      contacts_filtered = this.props.data.contacts.map((item) => {
        return item.first_name + " " + item.last_name + ", ";
      });
      created_by = this.props.users.filter((item) => {
        if (item.id == this.props.data.created_by) return true;
      });
      // lead = this.props.lead_list.filter(item => {
      //   if (item.id == this.props.data.lead)
      //     return true;
      // })
    }

    let status_list = [
      ["New", "New"],
      ["In Progress", "In Progress"],
      ["Completed", "Completed"],
    ];
    let priority_list = [
      ["Low", "Low"],
      ["Medium", "Medium"],
      ["High", "High"],
    ];

    let created_on;
    if (this.props.data.created_on)
      created_on = moment(this.props.data.created_on, dateFormat);
    else created_on = moment(new Date(), dateFormat);

    let due_date;
    if (this.props.data.due_date)
      due_date = moment(this.props.data.due_date, dateFormat);
    else due_date = null;

    let admins;
    admins = this.props.users.filter((item) => item.role === "ADMIN");

    if (requestType === "get" && due_date != null)
      due_date = due_date.format(dateFormat);

    let footer = [];
    if (this.props.requestType === "post" || this.props.requestType === "put") {
      footer = [
        <Button key="back" onClick={onCancel}>
          {t("general.cancel", "Cancel")}
        </Button>,
        <Button
          key="submit"
          loading={s.loading}
          type="primary"
          onClick={this.handleSubmit}
        >
          {btnText}
        </Button>,
      ];
    } else {
      footer = [
        <Button key="back" onClick={onCancel}>
          {t("general.cancel", "Cancel")}
        </Button>,
      ];
    }
    return (
      <Modal
        visible={visible}
        title={titleText}
        // okText={btnText}
        onCancel={onCancel}
        // onOk={onCreate}
        footer={footer}

        // okButtonProps={{ form: 'task-form', key: 'submit', htmlType: 'submit' }}
        // onOk={(e) => {
        //     e.stopPropagation();

        // }}
      >
        <LeadPreview
          singleData={this.state.singleData}
          singleLoading={this.state.singleLoading}
          visible={this.state.visible}
          handleState={this.handleState}
        />
        <Form
          layout="vertical"
          id="task-form"
          hideRequiredMark
          onSubmit={this.handleSubmit}
        >
          <Form.Item label={t("tasks.task_form.title", "Title")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{this.props.data.title}</span>
            ) : (
              getFieldDecorator("title", {
                initialValue: this.props.data.title,
                rules: [
                  {
                    required: true,
                    message: t(
                      "tasks.task_form.title_required",
                      "Please input the title of task!"
                    ),
                  },
                ],
              })(<Input name="title" type="text" />)
            )}
          </Form.Item>
          <Form.Item label={t("tasks.task_form.description", "Description")}>
            {requestType === "get" ? (
              <span className="ant-form-text">
                {this.props.data.description}
              </span>
            ) : (
              getFieldDecorator("description", {
                initialValue: this.props.data.description,
                // rules: [{ required: true, message: 'Please input the title of task!' }],
              })(<Input type="textarea" name="description" />)
            )}
          </Form.Item>
          <FormItem label={t("tasks.task_form.lead", "Lead")}>
            {requestType === "get"
              ? get(data, "lead") && this.viewValue(data.lead, true)
              : getFieldDecorator("lead", {
                  initialValue: Lib.setSelectValue(data.lead, "id", "name"),
                })(
                  <SelectQuery
                    urlKey={`lead-list-autocomplete`}
                    placeholder=""
                    token={localStorage.getItem("token")}
                    suffixIcon={<Icon type="caret-down" />}
                    valKey={"id"}
                    valLabel={"name"}
                  />
                )}
          </FormItem>
          <FormItem label={t("tasks.task_form.hours_worked", "Hours worked")}>
            {requestType === "get"
              ? this.props.data.hours_worked
              : getFieldDecorator("hours_worked", {
                  initialValue: this.props.data.hours_worked,
                  rules: [
                    {
                      type: "number",
                      // required: true, message: 'Description is required!'
                    },
                  ],
                })(<InputNumber name="hours_worked" />)}
          </FormItem>
          <FormItem label={t("tasks.task_form.due_date", "Due date")}>
            {requestType === "get"
              ? this.viewValue(due_date)
              : getFieldDecorator("due_date", {
                  initialValue: due_date,
                  rules: [
                    {
                      type: "object",
                      // required: true, message: 'Description is required!'
                    },
                  ],
                })(<DatePicker name="due_date" format={dateFormat} />)}
          </FormItem>
          <FormItem label={t("tasks.task_form.tags", "Tags")}>
            {requestType === "get"
              ? this.viewValue(tags_filtered)
              : getFieldDecorator("tags", {
                  initialValue: tags_filtered,
                  rules: [
                    {
                      type: "array",
                    },
                  ],
                })(
                  <Select
                    mode="multiple"
                    name="tags"
                    placeholder={t(
                      "tasks.task_form.tags_select",
                      "Select tags"
                    )}
                  >
                    {this.props.tags.map((item) => (
                      <Option key={item.slug} value={item.slug}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
          </FormItem>
          <FormItem label={t("tasks.task_form.contacts", "Contacts")}>
            {requestType === "get"
              ? this.viewValue(contacts_filtered)
              : getFieldDecorator("contacts", {
                  initialValue: contacts_filtered,
                  rules: [
                    {
                      type: "array",
                    },
                  ],
                })(
                  <Select
                    mode="multiple"
                    name="contacts"
                    placeholder={t(
                      "tasks.task_form.contacts_select",
                      "Select contacts"
                    )}
                  >
                    {this.props.contacts.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.first_name} {item.last_name}
                      </Option>
                    ))}
                  </Select>
                )}
          </FormItem>
          {this.props.data.created_by_asana ? (
            <Form.Item label={t("tasks.task_form.assigned_to", "Assigned to")}>
              {requestType === "get" ? (
                <span className="ant-form-text">
                  {this.props.data.assigned_to_string}
                </span>
              ) : (
                getFieldDecorator("assigned_to_string", {
                  initialValue: this.props.data.assigned_to_string,
                })(<Input name="assigned_to_string" type="text" />)
              )}
            </Form.Item>
          ) : (
            <FormItem label={t("tasks.task_form.assigned_to", "Assigned to")}>
              {requestType === "get"
                ? this.viewValue(users_filtered)
                : getFieldDecorator("assigned_to", {
                    initialValue: users_filtered,
                    rules: [
                      {
                        type: "array",
                        // required: true, message: 'Phone number is required!'
                      },
                    ],
                  })(
                    <Select
                      mode="multiple"
                      name="assigned_to"
                      placeholder={t(
                        "tasks.task_form.assigned_to_select",
                        "Select users"
                      )}
                    >
                      {admins.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.first_name} {item.last_name}
                        </Option>
                      ))}
                    </Select>
                    // <Input name="assigned_to" />
                  )}
            </FormItem>
          )}
          <FormItem label={t("tasks.task_form.status", "Status of task")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{this.props.data.status}</span>
            ) : (
              getFieldDecorator("status", {
                initialValue: this.props.data.status,
                rules: [
                  {
                    // required: true, message: 'Phone number is required!'
                  },
                ],
              })(
                <Select
                  name="status"
                  placeholder={t(
                    "tasks.task_form.status_select",
                    "Select status of task"
                  )}
                >
                  {status_list.map((item) => (
                    <Option key={item[0]} value={item[0]}>
                      {item[1]}
                    </Option>
                  ))}
                </Select>
              )
            )}
          </FormItem>
          <FormItem label={t("tasks.task_form.priority", "Priority of task")}>
            {requestType === "get"
              ? this.viewValue(data.priority)
              : getFieldDecorator("priority", {
                  initialValue: this.props.data.priority,
                  rules: [
                    {
                      // required: true, message: 'Phone number is required!'
                    },
                  ],
                })(
                  <Select
                    name="priority"
                    placeholder={t(
                      "tasks.task_form.priority_select",
                      "Select priority of task"
                    )}
                  >
                    {priority_list.map((item) => (
                      <Option key={item[0]} value={item[0]}>
                        {item[1]}
                      </Option>
                    ))}
                  </Select>
                )}
          </FormItem>

          <FormItem label={t("tasks.task_form.created_by", "Created by")}>
            {requestType === "get"
              ? this.viewValue(
                  created_by && created_by[0]
                    ? created_by[0].first_name + " " + created_by[0].last_name
                    : null
                )
              : getFieldDecorator("created_by", {
                  initialValue: this.props.data.created_by,
                  rules: [
                    {
                      type: "number",
                      // required: true, message: 'Phone number is required!'
                    },
                  ],
                })(
                  <Select
                    name="created_by"
                    placeholder={t(
                      "tasks.task_form.created_by_select",
                      "Select user"
                    )}
                  >
                    {admins.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.first_name} {item.last_name}
                      </Option>
                    ))}
                  </Select>
                )}
          </FormItem>

          {/* <FormItem> */}
          {/* <Button type="primary" htmlType="submit">
                            {btnText}
                        </Button>
                        <Button key="back" onClick={onCancel}>
                            Cancel
                        </Button> */}
          {/* {
                            this.props.requestType === 'put'
                                ?
                                <Button type="danger" style={{ margin: 8 }} onClick={this.handleDelete}>
                                    Delete
                                </Button>
                                :
                                ''
                        } */}
          {/* </FormItem> */}
        </Form>
      </Modal>
    );
  }
}

const TaskForm = Form.create()(withTranslation()(TaskFormInit));
<TaskForm wrappedComponentRef={(form) => (this.form = form)} />;
this.form;
export default withRouter(TaskForm);



// WEBPACK FOOTER //
// ./src/containers/Tasks/TaskForm.js